import { useEffect, useState } from "react";
import { Download, Share, X } from "lucide-react";
import { isStandalone, isIOS } from "../lib/push";

// "Install app" button.
// - Chrome / Edge / Android: fires the native install prompt (beforeinstallprompt).
// - iOS Safari (no prompt API): shows a small "tap Share → Add to Home Screen" hint.
// Hidden when already installed / running standalone.
const InstallPWA = ({ className = "" }) => {
  const [deferred, setDeferred] = useState(null);
  const [installed, setInstalled] = useState(isStandalone());
  const [showIosHint, setShowIosHint] = useState(false);
  const ios = isIOS();

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setDeferred(e); };
    const onInstalled = () => { setInstalled(true); setDeferred(null); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (installed) return null;
  // Show when a native prompt is available, or on iOS where install is manual.
  if (!deferred && !ios) return null;

  const onClick = async () => {
    if (deferred) {
      deferred.prompt();
      try { await deferred.userChoice; } catch (_) {}
      setDeferred(null);
    } else if (ios) {
      setShowIosHint((v) => !v);
    }
  };

  return (
    <div className={`relative ${className}`}>
      <button data-testid="install-pwa-btn" onClick={onClick}
        className="w-full inline-flex items-center justify-center gap-2 font-stencil font-black uppercase text-xs bg-[#D4A94A] hover:bg-[#E5BD60] text-black px-3 py-2 tactical-frame-sm transition-colors">
        <Download className="w-4 h-4" /> Install App
      </button>

      {ios && showIosHint && (
        <div data-testid="install-ios-hint" className="absolute bottom-full left-0 right-0 mb-2 bg-[#13151B] border border-[#D4A94A]/40 tactical-frame p-3 shadow-2xl z-50">
          <button data-testid="install-ios-hint-close" onClick={() => setShowIosHint(false)} className="absolute top-2 right-2 text-[#64748B] hover:text-white"><X className="w-3.5 h-3.5" /></button>
          <div className="overline text-[10px] mb-2 text-[#D4A94A]">Add OCE DOGS to Home Screen</div>
          <ol className="text-[11px] text-[#94A3B8] font-mono space-y-1.5 leading-relaxed">
            <li>1. Tap the <Share className="inline w-3 h-3 mx-0.5 text-[#D4A94A]" /> <span className="text-white">Share</span> button in Safari</li>
            <li>2. Scroll and choose <span className="text-white">"Add to Home Screen"</span></li>
            <li>3. Tap <span className="text-white">Add</span> — the app lands on your home screen</li>
          </ol>
        </div>
      )}
    </div>
  );
};

export default InstallPWA;
